// Token + API base persistence. The token is a tenant bearer token (org:secret on the
// server; the user pastes just the secret part). Stored in localStorage; never sent
// anywhere except the Praxis API.
const TOKEN_KEY = "praxis_token";
const BASE_KEY = "praxis_api_base";

export function getToken(): string {
  return localStorage.getItem(TOKEN_KEY) ?? "";
}
export function setToken(t: string): void {
  localStorage.setItem(TOKEN_KEY, t.trim());
}
export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

/** API base URL. Empty string = same origin (production behind the shared nginx). */
export function getApiBase(): string {
  return localStorage.getItem(BASE_KEY) ?? "";
}
export function setApiBase(b: string): void {
  localStorage.setItem(BASE_KEY, b.trim().replace(/\/$/, ""));
}
